module.exports = __webpack_public_path__ + "static/img/demo_profile5.8c3e837.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/demo_profile5.png
// module id = yJdV
// module chunks = 150